export let WS_BASE_URL = process.env.REACT_APP_MICROSERVICE_API_URL
if (process.env.REACT_APP_MICROSERVICE_API_WS_PROTOCOL) {
   WS_BASE_URL = `${process.env.REACT_APP_MICROSERVICE_API_WS_PROTOCOL}://${process.env.REACT_APP_MICROSERVICE_API_URL}`
}
export const WS_LAST_SCALES_READING = `${WS_BASE_URL}/last_weight_reading`
export const MAX_SCALES_READINGS = 30
export const ZERO_MASS_THRESHOLD_G = 2

export const SHOULD_SHOW_DEBUG = !!process.env.REACT_APP_SHOULD_SHOW_DEBUG

export const MAX_MS_SINCE_LAST_READING =
  Number.parseInt(process.env.MAX_MS_SINCE_LAST_READING ?? '') ||
  Math.trunc(0.5 * 1_000)

export const SCALES_READING_VALUE_UPDATE_THRESHOLD_G =
  Number.parseInt(process.env.SCALES_READING_VALUE_UPDATE_THRESHOLD_G ?? '') ||
  2
export const MIN_STABILIZATION_SCALES_READINGS =
  Number.parseInt(process.env.MIN_STABILIZATION_SCALES_READINGS ?? '') || 3
